/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import s from './Login.css'; // eslint-disable-line css-modules/no-unused-class
import Layout from '../../../components/global/Layout';
import MobileLogin from '../../../components/p_login/MobileLogin';
import ThirdLogin from '../../../components/p_login/ThirdLogin';
import * as loginActions from '../../../actions/login';
import { trackEventLog } from '../../../core/utils'

class Login extends React.Component {

  componentDidMount() {
    trackEventLog('LoginShow')
  }

  render() {
    const {
      backurl,
      logIn,
      virtualMobileTest,
    } = this.props

    // 处于bind状态下的登录框，不显示手机登录内容
    // const mobileShow1 = needbind ? !needbind : mobileShow
    return (
      <Layout loginDisabled>
        <div className={s.loginMain}>
          <header>
            <div // eslint-disable-line
              className={s.loginHeadActive}
            >手机号登录</div>
          </header>
          <div>
            <MobileLogin
              backurl={backurl}
              logIn={logIn}
              virtualMobilefetch={virtualMobileTest}
            />
            <ThirdLogin backurl={backurl} />
            <div className={s.tips}>
              登录代表已同意
              <a className={s.tipsLink} href="http://c.youdao.com/xue/legal.html">隐私政策</a>和
              <a className={s.tipsLink} href="http://c.youdao.com/xue/teenager.html">未成年人保护规则</a>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
    }
Login.propTypes = {
  backurl: PropTypes.string.isRequired,
  logIn: PropTypes.func.isRequired,
  virtualMobileTest: PropTypes.func.isRequired,
};

Login.contextTypes = {
  query: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    backurl: state.login.backurl,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(loginActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Login));



// WEBPACK FOOTER //
// ./src/routes/login/login/Login.js